module.exports = __webpack_public_path__ + "img/Tweety-Hsiao-WorldEd-31.09214f60.png";